import { XtpXdpConnectionProtocol } from 'data/xtp-xdp-connection/xtp-xdp-connection.types';
import { Xtp } from 'data/xtp/xtp.types';
import { Xdp } from 'data/xdp/xdp.types';

const adpatConnection = (xtpsIpAddrMap: { [key: string]: Xtp }) => {
  return (item: XtpXdpConnectionProtocol) => ({
    ...item,
    lbid: xtpsIpAddrMap[item.lbid as string]?.ipAddr ?? ''
  });
}

const getXtpsIpAddrMap = (xtps: Xtp[]) => xtps
  .reduce((total, actual) => ({ ...total, [actual.lbId]: actual }), {});

export const adptGridData = (
  data: XtpXdpConnectionProtocol[],
  xtps: Xtp[],
  xdps: Xdp[]
): XtpXdpConnectionProtocol[] => {
  const xtpsMap = getXtpsIpAddrMap(xtps);

  return data.map(adpatConnection(xtpsMap));
};

export default adptGridData;
